function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRatingYelp0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rating_x5F_yelp_x5F_0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "144px",
    height: "48px",
    viewBox: "0 0 144 48",
    style: {
      enableBackground: "new 0 0 144 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M22,36H6c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16 C26,34.209,24.209,36,22,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M51,36H35c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16 C55,34.209,53.209,36,51,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M80,36H64c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16 C84,34.209,82.209,36,80,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M109,36H93c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16 C113,34.209,111.209,36,109,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M138,36h-16c-2.209,0-4-1.791-4-4V16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16 C142,34.209,140.209,36,138,36z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "14,15.009 16.66,20.811 23,21.555 18.304,25.871 19.727,32.191 14,28.918 8.273,32.191  9.696,25.871 5,21.555 11.34,20.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "43,15.009 45.66,20.811 52,21.555 47.304,25.871 48.727,32.191 43,28.918 37.273,32.191  38.696,25.871 34,21.555 40.34,20.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72,15.009 74.66,20.811 81,21.555 76.304,25.871 77.727,32.191 72,28.918 66.273,32.191  67.696,25.871 63,21.555 69.34,20.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "101,15.009 103.66,20.811 110,21.555 105.304,25.871 106.727,32.191 101,28.918  95.273,32.191 96.696,25.871 92,21.555 98.34,20.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "130,15.009 132.66,20.811 139,21.555 134.304,25.871 135.727,32.191 130,28.918  124.273,32.191 125.696,25.871 121,21.555 127.34,20.811  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRatingYelp0);
export default __webpack_public_path__ + "static/media/icon-rating_yelp_0.989edbbc2ce8bba137522c5e5e5ab7d0.svg";
export { ForwardRef as ReactComponent };